import React from 'react'
import { DumbField } from 'components/Wizard2/Field'
import {
  Checkbox,
  RadioInput,
  TextInput,
  Select,
  FullName,
  NameOrg,
} from 'components/Wizard2/fieldComponents/Form'
import ServerOptions from 'components/Wizard2/fieldComponents/ServerControls'
import MultiComplete from 'components/Wizard2/fieldComponents/MultiComplete'
import DateRange from 'components/Wizard2/fieldComponents/DateRange'
import MountDetector from 'components/MountDetector/MountDetector'
import CaretDownIcon from '@tecuity/sos-icons/react/caret-down'
import CaretUpIcon from '@tecuity/sos-icons/react/caret-up'
import SearchIcon from '@tecuity/sos-icons/react/search-heavy'
import { getFirstFocusableScopedElement } from 'utilities'
import { Animate } from 'react-show'

class AdvancedParameters extends React.Component {
  state = {
    optionsCache: {},
    optionGroupsCache: {},
    searchHint: null,
  }
  focusFirstElement = () => {
    const firstElement = getFirstFocusableScopedElement('.search-advanced-animation-wrapper')
    if (firstElement) {
      firstElement.focus()
      const scrollWrapper = document.querySelector('.search-advanced-animation-wrapper')
      if (scrollWrapper) {
        scrollWrapper.scrollTop = 0
      }
    }
  }
  toggleAdvanced = () => {
    this.props.onRequestToggleDrawer(undefined, (open) => {
      if (!open && typeof this.props.onClose === 'function') {
        this.props.onClose()
      }
      if (open) {
        this.focusFirstElement()
      }
    })
  }
  hide = () => {
    this.props.onRequestToggleDrawer(false)
  }
  setValue = (value, name, param = {}) => {
    const calculatedValue = param.setValue ? param.setValue(value) : value
    this.props.onChange({
      ...this.props.values,
      [name]: calculatedValue,
    })
  }
  getYearOptions = (startYear) => {
    const currentYear = new Date().getFullYear()
    return Array(currentYear - parseInt(startYear || 1950, 10) + 1)
      .fill(null)
      .map((_, i) => {
        const year = (currentYear - i).toString()
        return { value: year, label: year }
      })
  }
  getOptionsBySrc = (src, param) => {
    switch (src) {
      case 'years':
        return [
          ...(param.preMergeOptions || []),
          ...this.getYearOptions(param.startYear),
          ...(param.postMergeOptions || []),
        ]
      default:
        return []
    }
  }
  getOptionsSrcOverrideValue = (param) => {
    return this.props.values[param.overrideOptionsSrcFromParameterName]
  }
  getSubOptionsSrcOverrideValue = (param) => {
    return this.props.values[param.overrideSubOptionsSrcFromParameterName]
  }
  showDisabledHint = () => {
    this.setState({
      searchHint:
        this.props.minimumSearchCharacters > 0
          ? `Minimum of ${
              this.props.minimumSearchCharacters || 2
            } Alpha-Numeric Characters Required`
          : `Please provide at least 1 valid search criteria to perform a search`,
    })
  }
  clearSearchHint = () => {
    this.setState({
      searchHint: null,
    })
  }
  render() {
    const { parameters = [], onSearchRequested, searching, startOpen, searchDisabled } = this.props
    const sharedTabIndex = this.props.open ? undefined : '-1'
    return (
      <React.Fragment>
        <Animate
          show={this.props.open}
          duration={350}
          transitionOnMount={!startOpen}
          className="search-advanced-animation-wrapper"
          style={{ height: 'auto' }}
          start={{ height: 0 }}
        >
          <div className="search-advanced-parameters-wrapper" aria-hidden={!this.props.open}>
            <div className="search-advanced-parameters wizard">
              <div>
                <div className="clear-wrapper">
                  <h2>Advanced Search</h2>
                </div>
                <MountDetector onMounted={this.focusFirstElement} />
                {parameters.map((rawParam) => {
                  const props =
                    typeof rawParam.getProps === 'function'
                      ? rawParam.getProps(this.props.values)
                      : {}
                  const param = { ...rawParam, ...props }
                  if (param.visible === false) return null                  

                  switch (param.Type) {
                    case 'h3':
                      return param.Label ? <h3 key={param.Name}>{param.Label}</h3> : null
                    case 'h4':
                      return param.Label ? <h4 key={param.Name}>{param.Label}</h4> : null
                    case 'text':
                      return (
                        <DumbField
                          key={param.Name}
                          label={param.Label}
                          description={param.description}
                          required={param.required || undefined}
                          fieldId={param.Name}
                          type="text"
                        >
                          <TextInput
                            onChange={(value) => {
                              this.setValue(value, param.Name, param)
                            }}
                            value={this.props.values[param.Name]}
                            width={param.width || '40%'}
                            tabIndex={sharedTabIndex}
                            ariaLabel={param.ariaLabel}
                            required={param.required || undefined}
                          />
                        </DumbField>
                      )
                    case 'radio':
                      return (
                        <DumbField
                          key={param.Name}
                          label={param.Label}
                          fieldId={param.Name}
                          type="radio"
                          ownsLabel
                        >
                          <RadioInput
                            onChange={(value) => {
                              this.setValue(value, param.Name, param)
                              if (param.Name === 'SearchType') {                                
                                if (value === 'Debtor' || value === 'SecuredParty' || value === 'RepresentedEntityName')
                                  this.props.onNameSearch(param.alternatePlaceholderText || true)
                                else this.props.onNameSearch(false)                                
                              }
                            }}
                            description={param.description}
                            options={param.Options}
                            value={this.props.values[param.Name]}
                            tabIndex={sharedTabIndex}
                            ariaLabel={param.ariaLabel}
                            label={param.Label}
                            ownsLabel
                          />
                        </DumbField>
                      )
                    case 'select':
                      return (
                        <DumbField
                          fieldId={param.Name}
                          label={param.Label}
                          description={param.description}
                          key={param.Name}
                          type="select"
                        >
                          <Select
                            fieldId={param.Name}
                            onChange={(value) => {
                              this.setValue(value, param.Name, param)
                            }}
                            options={param.Options}
                            value={this.props.values[param.Name]}
                            width={param.width || '40%'}
                            tabIndex={sharedTabIndex}
                            ariaLabel={param.ariaLabel}
                          />
                        </DumbField>
                      )
                    case 'checkbox':
                      return (
                        <DumbField
                          className="checkbox"
                          fieldId={param.Name}
                          key={param.Name}
                          type="checkbox"
                        >
                          <Checkbox
                            name={param.Name}
                            fieldId={param.Name}
                            onChange={(value) => {
                              this.setValue(value, param.Name, param)
                            }}
                            value={this.props.values[param.Name]}
                            label={param.Label}
                            tabIndex={sharedTabIndex}
                            ariaLabel={param.ariaLabel || param.Label}
                          />
                        </DumbField>
                      )
                    case 'dateRange':
                      return (
                        <DumbField
                          className="date-range"
                          label={param.Label}
                          description={param.description}
                          key={param.Name}
                          fieldId={param.Name}
                          type="DateRange"
                          ownsLabel
                        >
                          <div className="date-range-wrapper">
                            <DateRange
                              fieldId={param.Name}
                              onChange={(value) => {
                                this.setValue(value, param.Name, param)
                              }}
                              value={this.props.values[param.Name]}
                              label={param.Label}
                              startLabel="Start"
                              endLabel="End"
                              tabIndex={sharedTabIndex}
                              ariaLabel={param.ariaLabel || param.Label}
                              ownsLabel
                            />
                          </div>
                        </DumbField>
                      )
                    case 'serverSelect':
                      return (
                        <DumbField
                          fieldId={param.Name}
                          label={param.Label}
                          description={param.description}
                          key={param.Name}
                          type="serverSelect"
                        >
                          <ServerOptions
                            fieldId={param.Name}
                            controlType="select"
                            ariaLabel={param.ariaLabel}
                            onChange={(value) => {
                              this.setValue(value, param.Name, param)
                            }}
                            onBlur={() => {}}
                            value={this.props.values[param.Name]}
                            options={this.state.optionsCache[param.Name] || []}
                            optionGroups={this.state.optionGroupsCache[param.Name] || []}
                            optionsSrc={param.optionsSrc}
                            optionsFetched={!!this.state.optionsCache[param.Name]}
                            passFieldToOptionsHandler
                            disabled={
                              !this.state.optionsCache[param.Name] ||
                              !this.state.optionsCache[param.Name].length ||
                              param.disabled
                            }
                            tabIndex={sharedTabIndex}
                            placeholder={param.placeholder || '[Select an option]'}
                            optionsSrcOverrideValue={this.getOptionsSrcOverrideValue(param)}
                            subOptionsSrcOverrideValue={this.getSubOptionsSrcOverrideValue(param)}
                            includeAllOption={param.includeAllOption}
                            onOptionsFetchStarted={() => {
                              this.setState((state) => {
                                const { [param.Name]: deletedOpt, ...optionsCache } =
                                  state.optionsCache
                                const { [param.Name]: deletedOptGroup, ...optionGroupsCache } =
                                  state.optionGroupsCache
                                return { optionsCache, optionGroupsCache }
                              })
                            }}
                            onOptionsFetched={(options, optionGroups) => {
                              this.setState((state) => ({
                                optionsCache: {
                                  ...state.optionsCache,
                                  [param.Name]: options,
                                },
                                optionGroupsCache: {
                                  ...state.optionGroupsCache,
                                  [param.Name]: optionGroups,
                                },
                              }))
                            }}
                          />
                        </DumbField>
                      )
                    case 'ServerMultiComplete':
                      return (
                        <DumbField
                          label={param.Label}
                          description={param.description}
                          key={param.Name}
                          fieldId={param.Name}
                          type="ServerMultiComplete"
                        >
                          <ServerOptions
                            ariaLabel={param.Label}
                            controlType="ServerMultiComplete"
                            onChange={(value) => {
                              this.setValue(value, param.Name, param)
                            }}
                            onBlur={() => {}}
                            value={this.props.values[param.Name]}
                            options={this.state.optionsCache[param.Name] || []}
                            optionGroups={this.state.optionGroupsCache[param.Name] || []}
                            optionsSrc={param.optionsSrc}
                            optionsFetched={!!this.state.optionsCache[param.Name]}
                            includeAllOption={param.includeAllOption}
                            passFieldToOptionsHandler
                            tabIndex={sharedTabIndex}
                            disabled={
                              !this.state.optionsCache[param.Name] ||
                              !this.state.optionsCache[param.Name].length
                            }
                            placeholder={param.placeholder || '[Select an option]'}
                            optionsSrcOverrideValue={this.getOptionsSrcOverrideValue(param)}
                            subOptionsSrcOverrideValue={this.getSubOptionsSrcOverrideValue(param)}
                            onOptionsFetchStarted={() => {
                              this.setState((state) => {
                                const { [param.Name]: deletedOpt, ...optionsCache } =
                                  state.optionsCache
                                const { [param.Name]: deletedOptGroup, ...optionGroupsCache } =
                                  state.optionGroupsCache
                                return { optionsCache, optionGroupsCache }
                              })
                            }}
                            onOptionsFetched={(options, optionGroups) => {
                              this.setState((state) => ({
                                optionsCache: {
                                  ...state.optionsCache,
                                  [param.Name]: options,
                                },
                                optionGroupsCache: {
                                  ...state.optionGroupsCache,
                                  [param.Name]: optionGroups,
                                },
                              }))
                            }}
                            fieldId={param.Name}
                          />
                        </DumbField>
                      )
                    case 'MultiComplete':
                      return (
                        <DumbField
                          label={param.Label}
                          description={param.description}
                          fieldId={param.Name}
                          key={param.Name}
                          type="MultiComplete"
                        >
                          <MultiComplete
                            ariaLabel={param.Label}
                            fieldId={param.Name}
                            tabIndex={sharedTabIndex}
                            options={
                              param.optionsSrc
                                ? this.getOptionsBySrc(param.optionsSrc, param)
                                : param.options
                            }
                            value={this.props.values[param.Name]}
                            onBlur={() => {}}
                            onChange={(value) => {
                              this.setValue(value, param.Name, param)
                            }}
                          />
                        </DumbField>
                      )
                    case 'FullName':
                      return (
                        <DumbField
                          label={param.Label}
                          description={param.description}
                          fieldId={param.Name}
                          key={param.Name}
                          type="FullName"
                        >
                          <FullName
                            suffix={param.suffix}
                            tabIndex={sharedTabIndex}
                            onBlur={() => {}}
                            onChange={(value) => this.setValue(value, param.Name, param)}
                            value={this.props.values[param.Name]}
                            fieldId={param.Name}
                            classNameMap={{
                              firstName: 'col-sm-5 col-md-5 col-lg-4',
                              middleName: 'col-sm-4 col-md-3 col-lg-3',
                              lastName: 'col-sm-6 col-md-4 col-lg-4',
                            }}
                            required={param.required || undefined}
                          />
                        </DumbField>
                      )
                    case 'NameOrg':
                      return (
                        <DumbField
                          label={param.Label}
                          description={param.description}
                          fieldId={param.Name}
                          key={param.Name}
                          type="NameOrg"
                        >
                          <NameOrg
                            tabIndex={sharedTabIndex}
                            onBlur={() => {}}
                            onChange={(value) => this.setValue(value, param.Name, param)}
                            value={this.props.values[param.Name]}
                            fieldId={param.Name}
                            classNameMap={{
                              firstName: 'col-sm-5 col-md-5 col-lg-4',
                              middleName: 'col-sm-4 col-md-3 col-lg-3',
                              lastName: 'col-sm-6 col-md-4 col-lg-4',
                            }}
                          />
                        </DumbField>
                      )
                    default:
                      return null
                  }
                })}
                <div className="advanced-toolbar">
                  <div className="flex-row">
                    <button
                      className="btn btn-primary btn-raised advanced-search-button"
                      aria-disabled={searching || searchDisabled}
                      onClick={
                        searching || searchDisabled
                          ? this.showDisabledHint
                          : () => {
                              this.clearSearchHint()
                              onSearchRequested()
                            }
                      }
                      tabIndex={sharedTabIndex}
                      aria-busy={searching}
                      aria-invalid={searchDisabled}
                      aria-describedby="search-disabled-hint"
                      title={searchDisabled ? 'Minimum of one valid search criteria required' : ''}
                    >
                      <div className="center">
                        <SearchIcon alt="Search Icon" /> Search
                      </div>
                    </button>
                    <button
                      className="btn clear-button"
                      tabIndex={sharedTabIndex}
                      onClick={() => {
                        this.clearSearchHint()
                        this.props.clearFilters()
                      }}
                    >
                      Clear Filters
                    </button>
                  </div>
                  <p id="search-disabled-hint danger-text" aria-live="polite">
                    {this.state.searchHint ? (
                      <span className="search-disabled-hint">{this.state.searchHint}</span>
                    ) : null}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Animate>
        <div className="flex-row advanced-search-toggle-wrapper">
          <button
            className="advanced-search-toggle"
            aria-expanded={this.props.open}
            onClick={this.toggleAdvanced}
            style={{ transform: `translateY(${this.props.open ? -15 : 0}px)` }}
          >
            <span>Advanced {this.props.open ? <CaretUpIcon /> : <CaretDownIcon />}</span>
          </button>
        </div>
      </React.Fragment>
    )
  }
}

export default AdvancedParameters
